import { render, staticRenderFns } from "./bwg_power_manage.vue?vue&type=template&id=2d34e534&"
import script from "./bwg_power_manage.vue?vue&type=script&lang=js&"
export * from "./bwg_power_manage.vue?vue&type=script&lang=js&"
import style0 from "./bwg_power_manage.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports